import { confirmAction } from "../../../components/ui/confirmAction";
import Select from "../../../components/ui/Select";
import React, { useEffect, useState } from "react";
import { FiEdit2, FiLock } from "react-icons/fi";
import Button from "../../../components/ui/Button";
import { AdminUser, Role } from "../../../types/admin";
import { assignAdminRole } from "../../../services/adminService";
import { getApiErrorMessage } from "../../../utils/apiError";
import { RoleBadge, roleName } from "./MemberIdentity";

export default function RoleAssignment({ admin, roles, ownId, onUpdated }: { admin: AdminUser; roles: Role[]; ownId?: string; onUpdated: () => void }) {
  const [roleId, setRoleId] = useState(admin.role?.id || "");
  const [editing, setEditing] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const own = ownId === admin.id;
  useEffect(() => setRoleId(admin.role?.id || ""), [admin.role?.id]);
  const save = async () => {
    if (own || !roleId || roleId === admin.role?.id) return;
    if (!await confirmAction({ title: "Change role?", description: `${admin.name} will be assigned ${roleName(roles.find(role => role.id === roleId)?.name)}. Their existing sessions will be signed out.`, confirmLabel: "Change role" })) return;
    setBusy(true); setError("");
    try { await assignAdminRole(admin.id, roleId); setEditing(false); onUpdated(); }
    catch (err) { setError(getApiErrorMessage(err)); }
    finally { setBusy(false); }
  };
  return <div className="access-role-assignment">
    {editing ? <div className="access-role-editor">
      <Select className="access-role-select" aria-label={`Role for ${admin.email}`} value={roleId} disabled={busy} onChange={event => setRoleId(event.target.value)}>
        <option value="" disabled>No role</option>{roles.map(role => <option key={role.id} value={role.id}>{roleName(role.name)}</option>)}
      </Select>
      <div className="access-role-editor__actions"><Button size="small" variant="primary" disabled={busy || !roleId || roleId === admin.role?.id} onClick={save}>{busy ? "Saving…" : "Save role"}</Button>
        <Button size="small" variant="text" disabled={busy} onClick={() => { setEditing(false); setRoleId(admin.role?.id || ""); setError(""); }}>Cancel</Button></div>
    </div> : <div className="access-role-summary"><RoleBadge name={admin.role?.name} />
      {own ? <span className="access-own-role" title="You cannot change your own role"><FiLock aria-hidden="true" /> Your role</span> : <Button size="small" variant="text" aria-label={`Edit role for ${admin.name}`} disabled={!roles.length} onClick={() => setEditing(true)}><FiEdit2 aria-hidden="true" /> Edit</Button>}
    </div>}
    {error && <p role="alert" className="integration-error">{error}</p>}
  </div>;
}
